export default class ColorPanel extends PIXI.Container {
    constructor(colorList) {
        super();

        this._tweens = new P3.utils.TWEEN.Group();

        this.signals = {};
        this.signals.colorSelected = new P3.utils.MiniSignal();

        this._holders = [];

        this._createButtons(colorList);

        const states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_bucket_out");
        states.over = P3.assets.texture("btn_bucket_out");
        states.down = P3.assets.texture("btn_bucket_down");
        states.icon = P3.assets.texture("asset_delete_paint");

        this._clearButton = new P3.Button(states);
        this._clearButton.position.set(-50, 500);
        this._clearButton.signals.click.add((button) => this.signals.colorSelected.dispatch(button));
        this._holders[this._holders.length - 1].addChild(this._clearButton);

        this._clearButton.overSoundName = "sfx_rollover"

    }

    update() {
        this._tweens.update();
    }

    animateIn() {

        P3.audio.playSound("sfx_paint_appears_00");

        this.visible = true;

        for (let i = 0; i < this._holders.length; i++) {
            const holder = this._holders[i];

            holder.scale.set(0.9);
            holder.x = 100;

            new P3.utils.TWEEN.Tween(holder.scale, this._tweens)
                .delay(i * 40)
                .onStart(() => holder.visible = true)
                .to({x: 1, y: 1}, 210)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .start();

            new P3.utils.TWEEN.Tween(holder, this._tweens)
                .delay(i * 40)
                .to({x: 0}, 210)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .start();

        }
    }

    animateOut() {

        this.visible = false;

        for (let i = 0; i < this._holders.length; i++) {
            const holder = this._holders[i];
            holder.visible = false;
        }
    }

    _createButtons(colorList) {
        const spacing = 100;
        let spaceY = 0;
        for (let i = 0; i < colorList.length; i++) {

            const holder = new PIXI.Container();
            this.addChild(holder);
            this._holders.push(holder);

            const states = new P3.ButtonStates();
            states.normal = P3.assets.texture("btn_bucket_out");
            states.over = P3.assets.texture("btn_bucket_out");
            states.down = P3.assets.texture("btn_bucket_down");

            const button = new P3.Button(states);
            //button.clickSoundName = "sfx_click";
            button.overSoundName = "sfx_rollover";
            holder.addChild(button);

            const paint = new PIXI.Sprite(P3.assets.texture("btn_paint_out"));
            paint.anchor.set(0.5);
            paint.tint = new P3.math.Color().setHex(colorList[i]).toNumber();
            button.animation.addChild(paint);

            //button.color = paint.tint;
            button.color = colorList[i];

            // position button
            if (i % 2 === 1) {
                button.x = spacing * 0.5;
            } else {
                button.x = -spacing * 0.5;
                spaceY += spacing;
            }

            if (i === colorList.length - 1) {
                button.x = spacing * 0.5; //last button goes on RHS
            }

            button.y = spaceY;

            button.signals.click.add((button) => this.signals.colorSelected.dispatch(button));

        }
    }
}